module.exports = __webpack_public_path__ + "static/img/The World.d2f7d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The World.jpg
// module id = 1324
// module chunks = 0